import { useContext } from 'react';
import { ResponsiveContext } from '../../utils/responsive.es.js';

var useOrientation = function useOrientation(orientation) {
  var state = useContext(ResponsiveContext);
  return !!state.orientation[orientation];
};

export { useOrientation };